import request from '@/utils/request'

// 获取学科列表
export const getSubjectLists = (data) => {
    return request({
        url: '/subject/lists',
        params: data
    })
}

/**
 * 学科--学科选项
 */
export const getSubjectTree = () => {
    return request({
        url: '/subject/tree'
    })
}

/**
 * 学科--学院+学科tree
 */
export const getSubjectOption = () => {
    return request({
        url: '/subject/option/lists'
    })
}

// 学科-详情
export const getSubjectDetail = (id) => {
    return request({
        url: `/subject/${id}`
    })
}

// 学科-修改
export const putSubject = (data) => {
    return request({
        url: '/subject/manage',
        method: 'PUT',
        data
    })
}

// 学科-添加
export const addSubject = (data) => {
    return request({
        url: '/subject/manage',
        method: 'POST',
        data
    })
}

// 学科-删除
export const delSubjectModel = (id) => {
    return request({
        url: `/subject/${id}`,
        method: 'DELETE'
    })
}

// 批量启用
export const batchEnable = (data) => {
    return request({
        url: '/subject/manage',
        method: 'PATCH',
        data: {
            method: 'batch_enable',
            data
        }
    })
}

// 批量禁用
export const batchDisable = (data) => {
    return request({
        url: '/subject/manage',
        method: 'PATCH',
        data: {
            method: 'batch_disable',
            data
        }
    })
}

// 批量排序
export const batchSort = (data) => {
    return request({
        url: '/subject/manage',
        method: 'PATCH',
        data: {
            method: 'batch_update_order',
            data
        }
    })
}
